module.exports = __webpack_public_path__ + "static/media/previous.1254fec7.svg";